import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    label: '案件詳細',
    icon: 'ri-briefcase-4-line',
    src: '/image/sesly-hero.png',
    alt: 'Sesly 案件詳細・契約条件管理画面',
    caption: '1 / 5　案件詳細（契約条件・精算幅・継続登録・書類状況の起点）',
  },
  {
    label: '要対応',
    icon: 'ri-notification-3-line',
    src: '/image/sesly-home.png',
    alt: 'Sesly 要対応画面',
    caption: '2 / 5　要対応（期限が近づいた帳票作成・契約終了確認を自動通知）',
  },
  {
    label: '請求書受領チェック',
    icon: 'ri-checkbox-multiple-line',
    src: '/image/sesly-invoice-review.png',
    alt: 'Sesly 請求書受領チェック画面',
    caption: '3 / 5　請求書受領チェック（下位パートナーからの請求書受領状況を一覧管理）',
  },
  {
    label: '請求一覧',
    icon: 'ri-file-list-3-line',
    src: '/image/sesly-billing-list.png',
    alt: 'Sesly 請求一覧画面',
    caption: '4 / 5　請求一覧（対象月・ステータス別の管理とPDF一括ZIPダウンロード）',
  },
  {
    label: '売上分析',
    icon: 'ri-bar-chart-grouped-line',
    src: '/image/sesly-analysis.png',
    alt: 'Sesly 年次・月次売上分析画面',
    caption: '5 / 5　分析（請求データから年次・月次の売上・原価・粗利推移を自動集計）',
  },
];

const featureGroups = [
  {
    badge: 'CATEGORY 01',
    title: '営業の「毎月・毎回」の入力と確認の手間を減らす',
    items: [
      {
        num: 'FEATURE 01',
        icon: 'ri-notification-3-line',
        title: '時期が近づくと「要対応」でお知らせ',
        desc: 'やらなければならない帳票発行や、契約期間満了に伴う継続・終了確認は、時期が近づくと自動で「要対応」リストに表示。案件数が増えても優先順位が一目でわかります。',
        point: '会社ごとの期限ルール設定に対応',
      },
      {
        num: 'FEATURE 02',
        icon: 'ri-arrow-right-up-box-line',
        title: '案件継続時のカンタン内容引き継ぎ',
        desc: '契約更新・延長の際は、簡単な操作で既存案件のアサイン要員や契約条件、商流設定をそのまま新期間へ引き継ぎ可能。変更点だけを微調整してすぐに確定できます。',
        point: '日割り計算（稼働日数÷営業日数）も自動算出',
      },
      {
        num: 'FEATURE 03',
        icon: 'ri-history-line',
        title: '前回帳票の内容を記憶し、書き直し不要',
        desc: '前回帳票を作成した際の備考欄や記載内容、送付先の設定などが記憶されるため、毎月同じ文言を打ち直す必要がありません。定型業務のスピードと正確性が大幅に向上します。',
        point: '過去の記載ミスや表記ゆれも防止',
      },
    ],
  },
  {
    badge: 'CATEGORY 02',
    title: '帳票PDF作成・電子押印・メール送信をワンストップ化',
    items: [
      {
        num: 'FEATURE 04',
        icon: 'ri-file-pdf-2-line',
        title: '稼働時間の入力だけでPDF作成まで完結',
        desc: '月々の請求業務は、対象月の稼働時間を入力するだけ。契約条件をもとに精算額を自動計算し、きれいなPDF帳票を即座に出力します。一覧からの一括ZIPダウンロードも可能です。',
        point: '見積書・注文書・請求書を統一デザインで出力',
      },
      {
        num: 'FEATURE 05',
        icon: 'ri-mail-send-line',
        title: 'Gmail連携で送信＆メーラー側でも履歴確認',
        desc: '作成したPDFはアプリ内からそのままメール送信が可能。Google（Gmail）と連携しているため、送信したメールは普段お使いのGmailの「送信済み」フォルダからもそのまま確認・検索できます。',
        point: '宛先（TO/CC）やテンプレート変数も自動展開',
      },
      {
        num: 'FEATURE 06',
        icon: 'ri-stamp-line',
        title: '既存PDFへの直接印字・押印出力（注文請書など）',
        desc: '取引先から届いた注文請書などのPDFを読み込み、画面上で社判（ハンコ）・会社名・住所・テキストをドラッグ配置して、印字・押印済みの別PDFとしてそのまま出力できます。',
        point: '紙に印刷してハンコを押してスキャンする手間をゼロに',
      },
    ],
  },
  {
    badge: 'CATEGORY 03',
    title: '受領・入金チェックから履歴照会、売上分析まで一元化',
    items: [
      {
        num: 'FEATURE 07',
        icon: 'ri-checkbox-multiple-line',
        title: '請求書受領チェック・入金チェック機能',
        desc: 'パートナー（下位会社）から届く請求書の受領確認や、請求先からの月次入金確認を一覧でチェック・記録。営業担当と経理・バックオフィス間の確認作業がスムーズになります。',
        point: '対象月ごとの未受領・未入金が一目瞭然',
      },
      {
        num: 'FEATURE 08',
        icon: 'ri-team-line',
        title: '取引先・要員から過去の参画案件をすぐ確認',
        desc: '取引先マスタや要員マスタの詳細画面から、過去に参画した案件履歴や現在の契約状況、関連する帳票をいつでも振り返ることができます。「あの要員、以前どの案件にいたっけ？」に即答できます。',
        point: '商流（上位・下位）の関係性もクリアに把握',
      },
      {
        num: 'FEATURE 09',
        icon: 'ri-bar-chart-grouped-line',
        title: '請求データから年次・月次で売上分析',
        desc: '日々の業務で作成された請求書・注文書のデータから、年次・月次での売上・原価・粗利を自動集計。集計用の別シートを作ることなく、リアルタイムに数字を把握できます。',
        point: 'プロパー／BP別の内訳や推移の確認にも対応',
      },
    ],
  },
];

const SeslyMain = () => {
  const [current, setCurrent] = useState(0);
  const total = slides.length;

  const showSlide = (index: number) => {
    setCurrent((index + total) % total);
  };

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)) {
        return;
      }
      if (event.key === 'ArrowLeft') {
        setCurrent((value) => (value - 1 + total) % total);
      }
      if (event.key === 'ArrowRight') {
        setCurrent((value) => (value + 1) % total);
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [total]);

  return (
    <main className="sesly-page">
      <section className="hero-section">
        <div className="hero-bg-decor">
          <div className="hero-bg-decor__circle hero-bg-decor__circle--1"></div>
          <div className="hero-bg-decor__circle hero-bg-decor__circle--2"></div>
          <div className="hero-bg-decor__circle hero-bg-decor__circle--3"></div>
        </div>

        <div className="hero-grid">
          <div>
            <div className="hero-badges">
              <span className="badge"><i className="ri-shield-check-line"></i> 自社内で毎日実稼働中</span>
              <span className="badge badge--outline"><i className="ri-settings-4-line"></i> 貴社仕様へのカスタマイズ提供対応</span>
            </div>

            <div className="hero-brand">
              <img className="hero-brand__icon" src="/image/sesly-icon.png" alt="Sesly アイコン" />
              <div>
                <h1 className="hero-brand__title">Sesly</h1>
                <p className="hero-brand__sub">- SES Sales &amp; Backoffice System -</p>
              </div>
            </div>

            <p className="hero-catch">
              案件を取ってきたあとの「毎月」を、もっと身軽に。<br />
              営業のために生まれた、案件起点のSES業務管理ツール。
            </p>

            <p className="hero-lead">
              案件を獲得してから始まる、見積・注文・月次請求・契約更新・入金確認——。<br />
              忙しい営業担当者の月々の事務負担を少しでも減らしたいという想いから、現場の「こういうのが欲しい」をすべて詰め込んで開発した社内実践型システムです。<br />
              当社で日々稼働しているベースシステムをもとに、貴社の商流や帳票ルールに合わせてカスタマイズしてご提供します。
            </p>

            <div className="btn-group">
              <Link className="btn btn--primary" to="/contact">
                <i className="ri-mail-send-line"></i> 導入・カスタマイズのご相談
              </Link>
              <a className="btn btn--outline" href="#promo-movie">
                <i className="ri-play-circle-line"></i> 実画面デモ動画を見る（約1分）
              </a>
              <a className="btn btn--outline" href="#features">
                <i className="ri-list-check-2"></i> 機能一覧を見る
              </a>
            </div>
          </div>

          <div className="hero-slider" aria-label="Sesly 代表画面プレビュー">
            <div className="hero-slider__tabs" role="tablist" aria-label="画面切り替えタブ">
              {slides.map((slide, index) => (
                <button
                  key={slide.label}
                  type="button"
                  className={`hero-slider__tab${index === current ? ' is-active' : ''}`}
                  role="tab"
                  aria-selected={index === current}
                  onClick={() => showSlide(index)}
                >
                  <i className={slide.icon}></i> {slide.label}
                </button>
              ))}
            </div>

            <div className="hero-slider__viewport">
              <button
                type="button"
                className="hero-slider__arrow hero-slider__arrow--prev"
                aria-label="前の画面へ"
                onClick={() => showSlide(current - 1)}
              >
                <i className="ri-arrow-left-s-line"></i>
              </button>

              {slides.map((slide, index) => (
                <figure
                  key={slide.src}
                  className={`hero-slider__slide${index === current ? ' is-active' : ''}`}
                >
                  <img src={slide.src} alt={slide.alt} />
                </figure>
              ))}

              <button
                type="button"
                className="hero-slider__arrow hero-slider__arrow--next"
                aria-label="次の画面へ"
                onClick={() => showSlide(current + 1)}
              >
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>

            <div className="hero-slider__footer">
              <p className="hero-slider__caption">{slides[current].caption}</p>
              <div className="hero-slider__dots" aria-label="スライドインジケーター">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`hero-slider__dot${index === current ? ' is-active' : ''}`}
                    aria-label={`画面${index + 1}`}
                    onClick={() => showSlide(index)}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--tint section--promo" id="promo-movie">
        <div className="container">
          <div className="section-header" style={{ marginBottom: 28 }}>
            <p className="eyebrow">1-Minute Live Demo</p>
            <h2 className="section-title">1分でわかる「Sesly」の実際の操作感</h2>
            <p className="section-desc">
              要対応アラートから案件起点の管理、稼働時間入力による月次請求・PDF出力・Gmail送信、受領確認・参画履歴・売上分析まで、実際の画面操作を約1分にまとめました（音声なし）。<br />
              ※動画内の社名・人物・請求額等はすべて架空のものです
            </p>
          </div>

          <div className="promo-video">
            <video
              src="/image/sesly-promo.mp4"
              autoPlay
              muted
              loop
              playsInline
              controls
            ></video>
          </div>
        </div>
      </section>

      <section className="section" id="concept">
        <div className="container">
          <div className="section-header">
            <p className="eyebrow">Concept</p>
            <h2 className="section-title">営業の人のために作った、「案件」がすべての起点になる設計</h2>
            <p className="section-desc">
              帳票ごとにバラバラのExcelやツールへ同じ情報を何度も打ち直す——。<br />
              そんな毎月のムダをなくすため、Seslyは登録のベースを「案件」に一本化しました。
            </p>
          </div>

          <div className="concept-box">
            <div className="concept-grid">
              <div>
                <h3 style={{ fontSize: 20, fontWeight: 700, color: 'var(--msk-green)', margin: '0 0 14px', lineHeight: 1.5 }}>
                  案件を取ってきてから始まる、<br />営業の「月々の作業負担」を減らしたい。
                </h3>
                <p style={{ fontSize: '13.5px', color: 'var(--msk-text)', margin: '0 0 14px', lineHeight: 1.9 }}>
                  SESの営業担当者は、案件を決めたあとも見積書・注文書の発行、毎月の稼働時間の回収、請求書の作成・送付、パートナーからの請求書受領確認、そして契約更新の手続きと、毎月多くの事務作業を抱えています。
                </p>
                <p style={{ fontSize: '13.5px', color: 'var(--msk-text)', margin: 0, lineHeight: 1.9 }}>
                  Seslyでは、取引先・要員・契約期間・単価・精算条件を<strong>「案件」として一度登録すれば、その後の見積・注文・毎月の請求・売上分析までがすべて連動</strong>します。現場で「こういう機能が欲しかった」と感じた工夫を細部まで詰め込んでいます。
                </p>

                <ul className="concept-points">
                  <li>
                    <i className="ri-checkbox-circle-fill"></i>
                    <span><strong>二度手間を徹底排除：</strong> 案件の条件や前回の帳票内容を記憶し、毎月の書き直しをゼロへ。</span>
                  </li>
                  <li>
                    <i className="ri-checkbox-circle-fill"></i>
                    <span><strong>うっかり忘れを仕組みで防ぐ：</strong> 時期が近づいた作業はシステム側から「要対応」でお知らせ。</span>
                  </li>
                  <li>
                    <i className="ri-checkbox-circle-fill"></i>
                    <span><strong>営業から経理・経営までつながる：</strong> 受領・入金チェックや売上分析まで1つのデータで完結。</span>
                  </li>
                </ul>
              </div>

              <div className="hub-diagram">
                <div className="hub-core">
                  <p className="hub-core__title"><i className="ri-folder-shield-2-line"></i> ベース登録：「案件（プロジェクト）」</p>
                  <p className="hub-core__sub">取引先（上位・下位）／ 参画要員 ／ 契約期間 ／ 単価・精算幅・支払サイト</p>
                </div>
                <div className="hub-arrows">
                  <i className="ri-arrow-down-double-line"></i>
                  <span>1つの案件データから、すべての業務が自動連動</span>
                  <i className="ri-arrow-down-double-line"></i>
                </div>
                <div className="hub-branches">
                  <div className="hub-branch">
                    <i className="ri-file-list-3-line"></i>
                    <div>
                      <div>見積書・注文書の作成</div>
                      <div style={{ fontSize: 11, color: 'var(--msk-muted)', fontWeight: 400 }}>条件をそのまま反映してPDF化</div>
                    </div>
                  </div>
                  <div className="hub-branch">
                    <i className="ri-time-line"></i>
                    <div>
                      <div>月次請求（稼働時間入力のみ）</div>
                      <div style={{ fontSize: 11, color: 'var(--msk-muted)', fontWeight: 400 }}>超過・控除も自動計算しGmail送信</div>
                    </div>
                  </div>
                  <div className="hub-branch">
                    <i className="ri-refresh-line"></i>
                    <div>
                      <div>契約継続のワンタッチ引き継ぎ</div>
                      <div style={{ fontSize: 11, color: 'var(--msk-muted)', fontWeight: 400 }}>次期間の案件へ条件を丸ごとコピー</div>
                    </div>
                  </div>
                  <div className="hub-branch">
                    <i className="ri-line-chart-line"></i>
                    <div>
                      <div>受領・入金確認 ＆ 売上分析</div>
                      <div style={{ fontSize: 11, color: 'var(--msk-muted)', fontWeight: 400 }}>月次・年次の売上と粗利を可視化</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--soft" id="workflow">
        <div className="container">
          <div className="section-header">
            <p className="eyebrow">Monthly Workflow</p>
            <h2 className="section-title">月々のルーティンが、驚くほどシンプルに</h2>
            <p className="section-desc">
              「今月どの案件の書類が必要か」を探すところから、PDF作成・メール送付・継続手続きまで、<br />
              迷わず最短手順で進められる導線を設計しています。
            </p>
          </div>

          <div className="workflow-grid">
            <div className="workflow-step">
              <span className="workflow-step__num">STEP 01</span>
              <div className="workflow-step__icon"><i className="ri-alarm-warning-line"></i></div>
              <h3 className="workflow-step__title">「要対応」でやるべきことを自動通知</h3>
              <p className="workflow-step__desc">
                時期が近づいてきた見積・注文・請求の作成や、契約終了・継続の確認事項は、ホーム画面の「要対応」に自動で集約。期限超過や対応漏れを防ぎます。
              </p>
            </div>
            <div className="workflow-step">
              <span className="workflow-step__num">STEP 02</span>
              <div className="workflow-step__icon"><i className="ri-calculator-line"></i></div>
              <h3 className="workflow-step__title">月々の請求は「稼働時間」を入れるだけ</h3>
              <p className="workflow-step__desc">
                毎月の請求書作成は、要員の稼働時間を入力するだけ。上限・下限時間に応じた超過・控除額も自動計算され、前回の備考内容も記憶された状態で即座にPDFを作成できます。
              </p>
            </div>
            <div className="workflow-step">
              <span className="workflow-step__num">STEP 03</span>
              <div className="workflow-step__icon"><i className="ri-mail-check-line"></i></div>
              <h3 className="workflow-step__title">Gmail連携で画面からそのままメール送信</h3>
              <p className="workflow-step__desc">
                作成した帳票PDFは、Seslyの画面上からそのまま取引先へメール送信可能。Gmailと連携しているため、送信履歴や添付内容は普段のメーラー（送信済み）側でも確認できます。
              </p>
            </div>
            <div className="workflow-step">
              <span className="workflow-step__num">STEP 04</span>
              <div className="workflow-step__icon"><i className="ri-file-copy-2-line"></i></div>
              <h3 className="workflow-step__title">案件継続も簡単操作でスムーズ引き継ぎ</h3>
              <p className="workflow-step__desc">
                案件が継続する際は、ボタンひとつで前期間の取引先・要員・単価・精算条件を引き継いで次期間の案件を作成可能。更新のたびに一から入力し直す必要はありません。
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section" id="features">
        <div className="container">
          <div className="section-header">
            <p className="eyebrow">Key Features</p>
            <h2 className="section-title">「こういうのが欲しい」をすべて詰め込んだ便利機能</h2>
            <p className="section-desc">
              営業現場の小さなストレスを解消する工夫から、バックオフィス・経営層の確認業務を助ける機能まで、<br />
              実務で本当に役立つ機能を網羅しています。
            </p>
          </div>

          {featureGroups.map((group) => (
            <div className="feature-category" key={group.badge}>
              <div className="feature-category__head">
                <span className="feature-category__badge">{group.badge}</span>
                <h3 className="feature-category__title">{group.title}</h3>
              </div>
              <div className="feature-grid-3">
                {group.items.map((item) => (
                  <article className="feature-card" key={item.num}>
                    <div className="feature-card__top">
                      <div className="feature-card__icon"><i className={item.icon}></i></div>
                      <span className="feature-card__num">{item.num}</span>
                    </div>
                    <h4 className="feature-card__title">{item.title}</h4>
                    <p className="feature-card__desc">{item.desc}</p>
                    <div className="feature-card__point">
                      <i className="ri-check-line"></i> {item.point}
                    </div>
                  </article>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="section section--tint" id="customize">
        <div className="container">
          <div className="section-header">
            <p className="eyebrow">Customization &amp; Delivery</p>
            <h2 className="section-title">自社で毎日使っているツールを、貴社仕様にカスタマイズしてご提供</h2>
            <p className="section-desc">
              Seslyは現在、株式会社MSKの社内業務基盤として実際に稼働しているシステムです。<br />
              パッケージの押し付けではなく、貴社固有の商流・帳票フォーマット・運用ルールに合わせて柔軟にカスタマイズしてご提供します。
            </p>
          </div>

          <div className="custom-grid">
            <div className="custom-item">
              <div className="custom-item__icon"><i className="ri-file-edit-line"></i></div>
              <div>
                <h5>帳票デザイン・印影・番号ルールの調整</h5>
                <p>貴社で現在お使いの見積書・注文書・請求書のレイアウトや採番ルール、ロゴ・角印の配置、インボイス登録番号表記などに合わせてPDF出力仕様を調整します。</p>
              </div>
            </div>
            <div className="custom-item">
              <div className="custom-item__icon"><i className="ri-git-branch-line"></i></div>
              <div>
                <h5>独自の商流・契約形態への対応</h5>
                <p>通常のSES準委任契約だけでなく、営業支援費モデルの商流や、月額ライセンス・自社プロダクトの継続請求など、貴社のビジネスモデルに合わせた画面・計算ロジックを組み込めます。</p>
              </div>
            </div>
            <div className="custom-item">
              <div className="custom-item__icon"><i className="ri-lock-password-line"></i></div>
              <div>
                <h5>権限設計・アラート期限の最適化</h5>
                <p>営業・経理・管理者といったロールごとの閲覧・操作権限の調整や、「何日前から要対応に出すか」といった社内規定に合わせた期限設定が可能です。</p>
              </div>
            </div>
            <div className="custom-item">
              <div className="custom-item__icon"><i className="ri-server-line"></i></div>
              <div>
                <h5>ご利用環境・既存ツールに合わせた導入支援</h5>
                <p>社内サーバーや専用クラウド（VPS等）への構築、Googleアカウントログイン・Gmail連携の設定、自動バックアップ構成、既存マスタデータの初期移行までトータルでサポートします。</p>
              </div>
            </div>
          </div>

          <div className="spec-card" style={{ marginTop: 40 }}>
            <h3 style={{ fontSize: 18, fontWeight: 700, color: 'var(--msk-green)', margin: '0 0 16px' }}>
              ご提供イメージ・システム概要
            </h3>
            <div>
              <div className="spec-row">
                <div className="spec-row__dt">利用環境</div>
                <p className="spec-row__dd">Webブラウザ（PC / タブレット等のブラウザから社内・拠点間で共有利用可能）</p>
              </div>
              <div className="spec-row">
                <div className="spec-row__dt">主な搭載機能</div>
                <p className="spec-row__dd">
                  要対応アラート ／ 案件管理（通常・営業支援費・継続引継・日割り計算） ／ 見積・注文・請求PDF作成 ／ Gmail連携メール送信 ／ 注文請書PDFスタンプ印字 ／ 請求書受領・入金チェック ／ 取引先・要員マスタ＆参画履歴 ／ 年次・月次売上分析 ／ ロール権限・自動バックアップ
                </p>
              </div>
              <div className="spec-row">
                <div className="spec-row__dt">提供形態</div>
                <p className="spec-row__dd">貴社専用環境への導入（クラウド / オンプレミス）＋ 業務フローに合わせた個別カスタマイズ</p>
              </div>
              <div className="spec-row">
                <div className="spec-row__dt">料金</div>
                <p className="spec-row__dd">個別お見積もり（ご利用規模・カスタマイズ範囲に応じてご提案いたします）</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container--narrow">
          <div className="cta-box">
            <h4>デモのご覧・カスタマイズのご相談はお気軽に</h4>
            <p>
              「実際の画面を見てみたい」「自社の請求フローに合うよう少し変えて導入したい」など、<br />
              現場を熟知したエンジニア・担当者が貴社の課題に合わせてご提案いたします。
            </p>

            <ul className="cta-list">
              <li>社内実稼働環境をベースにしたオンラインデモのご案内</li>
              <li>現在のExcel・スプレッドシート管理からの移行・カスタマイズ相談</li>
              <li>SES業務以外の社内向け業務アプリ・管理ツールのオーダーメイド開発</li>
            </ul>

            <div className="btn-group btn-group--center">
              <Link className="btn btn--primary" to="/contact">お問い合わせ</Link>
              <Link className="btn btn--outline" to="/products">プロダクト一覧へ</Link>
            </div>

            <div className="cta-note">
              お問い合わせの件名例：「Seslyについて」「SES管理ツールのデモ・カスタマイズ相談」
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SeslyMain;
